import { decode } from 'html-entities';

const parseHtmlToString = (htmlString) => {
    let decodedStr = decode(htmlString);

    decodedStr = decodedStr.replace(/&nbsp;/g, '');

    decodedStr = decodedStr.replace(/<b>([^<]+)<\/b>/g, '\n$1\n');
    // decodedStr = decodedStr.replace(/OR/g, '\nOR');
    // decodedStr = decodedStr.replace(/AND/g, '\nAND');
    decodedStr = decodedStr.replace(/<li>/g, '');
    // decodedStr = decodedStr.replace(/<\/li>/g, '\n');
    decodedStr = decodedStr.replace(/<\/ul>/g, '\n');
    // decodedStr = decodedStr.replace(/<[^\/>]+>/g, '\n');
    decodedStr = decodedStr.replace(/<[^>]+>/g, '');
    return decodedStr;
};

export default parseHtmlToString;
